import ViewerConfig from '../constants/ViewerConfig';

const PDFFontNormalizer = {
  toPixelFontSize(styleProps, scale) {
    if (!styleProps.fontSize) {
      return styleProps.fontSize;
    }

    const fontSizePoint = styleProps.fontSize;
    return fontSizePoint * ViewerConfig.CSS_UNITS * scale;
  },

  toPixelSizeStyleProps(styleProps, scale) {
    if (!this.validateStyleProps(styleProps)) {
      throw new TypeError('styleProps must be object');
    }

    if (!styleProps.fontSize) return styleProps;

    const fontSize = this.toPixelFontSize(styleProps, scale);
    return { ...styleProps, fontSize };
  },

  validateStyleProps(styleProps) {
    return styleProps && typeof styleProps === 'object';
  },
};

export default PDFFontNormalizer;
